import { render, staticRenderFns } from "./Composer.html?vue&type=template&id=8ab531b2&scoped=true&"
import script from "./Composer.js?vue&type=script&lang=js&"
export * from "./Composer.js?vue&type=script&lang=js&"
import style0 from "./Composer.scss?vue&type=style&index=0&id=8ab531b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab531b2",
  null
  
)

export default component.exports